// 
import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useReducer, useState, ActivityIndicator, useRef } from "react"
import { ImageStyle, Platform, ScrollView, TextStyle, ViewStyle, SafeAreaView, FlatList, Dimensions, DeviceEventEmitter } from "react-native"

import { api } from "../../services/api"
import { colors, spacing } from "../../theme"
import { View, Text, TextField, Card, Checkbox, DateTimePicker, Picker, SegmentedControl, Assets, Spacings, Colors, BorderRadiuses, Timeline, GridList, GridView, Modal, SortableList, SortableGridList, Image, Button, TabController, FloatingButton, TouchableOpacity, Dialog, PanningProvider, Chip, ActionSheet } from 'react-native-ui-lib';
import DynamicForm, { CustomDatePicker, CustomModal, CustomNumberInput, CustomSelect, CustomTextField, SecondaryButton } from "../DynamicForm"
import DynamicTable from "../DynamicTable"
import { useNavigation } from '@react-navigation/native';
import Svg, { Path, G, Circle } from "react-native-svg";
import { LinearGradient } from 'expo-linear-gradient'
import { BoxShadow } from 'react-native-shadow'
import { useStores } from "../state";
import FormScreen from "./FormScreen"
import { useMatch, useNavigate, useRoutes, useSearchParams } from "react-router-dom";
import { Dropdown } from "antd"
import { Icon } from "react-native-eva-icons"
import LayoutScreen from "./LayoutScreen"
import dayjs from "dayjs"
import { GlobalMasterStore } from "../state/PermissionStore"
import moment from "moment"

const ReportScreenSingle = (props) => {
  let navigation = useNavigation();
  let navigate = null;

  let route = props?.route;
  let queryParams = { ...(props?.route?.params || {}) };

  if (Platform.OS === 'web') {
    navigate = useNavigate();
    let path = window?.location?.pathname;
    route = { name: path.split("/")[2] || 'Items' }

    const params = window.location.search.substring(1).split('&')
    params.map((param) => {
      const [key, value] = param.split('=')
      if (key) {
        queryParams[key] = value;
      }
    })
  }

  const navigationFn = (path, params) => {
    if (Platform.OS === 'web') {
      let paramsString = "";
      if (params) {
        paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
      }
      navigate("/" + path + paramsString);
    } else {
      if (path.includes("report/")) {
        navigation.navigate("report", {
          ...params,
          name: path.replace("report/", ""),
        });
      } else {
        navigation.navigate(path, params);
      }
    }
  };

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [filters, setFilters] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ids, setIds] = useState([]);
  const [groupBy, setGroupBy] = useState(null);
  const [groupByModal, setGroupByModal] = useState(false);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({
    field: null,
    label: null,
    operator: null,
    operator_label: null,
    operators: [],
    type: "text",
    value: null
  });

  const settingsMap = {
    "InventorySummary": {
      showDateRange: true,
      customFilter: (props) => {
        const searchTimeOutRef = useRef(null);
        const [itemName, setItemName] = useState(props.tabFilter.item_name || null);

        useEffect(() => {
          if (itemName !== null && itemName != props.tabFilter.item_name) {
            const obj = {
              ...props.tabFilter,
              item_name: itemName
            };

            if (!itemName) {
              delete obj.item_name;
            }

            if (searchTimeOutRef.current) {
              clearTimeout(searchTimeOutRef.current);
            }

            searchTimeOutRef.current = setTimeout(() => {
              props.setTabFilter(obj)
            }, 500);
          }
        }, [itemName])


        return <View row marginB-10>
          <View>
            <CustomTextField placeholder="Item Name" value={itemName} onChange={(val) => {
              setItemName(val);
            }} />
          </View>
          <View marginL-10 style={{
            width: 200
          }}>
            <CustomSelect placeholder="Item Category" value={props.tabFilter.item_category_id} options={
              (props.createData?.ItemCategories || []).map((group) => ({ ...group, label: group.name, value: group._id }))
            } onChange={(val) => {
              const obj = {
                ...props.tabFilter,
                item_category_id: val
              };

              if (!val) {
                delete obj.group_id;
              }
              props.setTabFilter(obj)
            }} />
          </View>
        </View>
      }
    },
    "InventoryDetailByItem": {
      showDateRange: true,
    },
    "LocationReport": {
      showDateRange: true,
    },

    "CustomerBalance": {
      showEndDate: true,
    },
    "SalesByCustomer": {
      showDateRange: true,
      defaultStartDate: moment().startOf('day').toDate(),
      defaultEndDate: moment().endOf('day').toDate(),
    },
    "SalesByItem": {
      showDateRange: true,
      customFilter: (props) => {
        const searchTimeOutRef = useRef(null);
        const [itemName, setItemName] = useState(props.tabFilter.item_name || null);

        useEffect(() => {
          if (itemName !== null && itemName != props.tabFilter.item_name) {
            const obj = {
              ...props.tabFilter,
              item_name: itemName
            };

            if (!itemName) {
              delete obj.item_name;
            }

            if (searchTimeOutRef.current) {
              clearTimeout(searchTimeOutRef.current);
            }

            searchTimeOutRef.current = setTimeout(() => {
              props.setTabFilter(obj)
            }, 500);
          }
        }, [itemName])


        return <View row marginB-10>
          <View>
            <CustomTextField placeholder="Item Name" value={itemName} onChange={(val) => {
              setItemName(val);
            }} />
          </View>
          <View marginL-10 style={{
            width: 200
          }}>
            <CustomSelect placeholder="Item Category" value={props.tabFilter.item_category_id} options={
              (props.createData?.ItemCategories || []).map((group) => ({ ...group, label: group.name, value: group._id }))
            } onChange={(val) => {
              const obj = {
                ...props.tabFilter,
                item_category_id: val
              };

              if (!val) {
                delete obj.group_id;
              }
              props.setTabFilter(obj)
            }} />
          </View>
        </View>
      }
    },
    "SaleByItemCategory": {
      showDateRange: true,
      customFilter: (props) => {
        const searchTimeOutRef = useRef(null);
        const [itemName, setItemName] = useState(props.tabFilter.item_name || null);

        useEffect(() => {
          if (itemName !== null && itemName != props.tabFilter.item_name) {
            const obj = {
              ...props.tabFilter,
              item_name: itemName
            };

            if (!itemName) {
              delete obj.item_name;
            }

            if (searchTimeOutRef.current) {
              clearTimeout(searchTimeOutRef.current);
            }

            searchTimeOutRef.current = setTimeout(() => {
              props.setTabFilter(obj)
            }, 500);
          }
        }, [itemName])


        return <View row marginB-10>
          <View marginL-10 style={{
            width: 200
          }}>
            <CustomSelect placeholder="Item Category" value={props.tabFilter.item_category_id} options={
              (props.createData?.ItemCategories || []).map((group) => ({ ...group, label: group.name, value: group._id }))
            } onChange={(val) => {
              const obj = {
                ...props.tabFilter,
                item_category_id: val
              };

              if (!val) {
                delete obj.group_id;
              }
              props.setTabFilter(obj)
            }} />
          </View>
        </View>
      }
    },
    "SalesRegister": {
      showDateRange: true,
    },

    "SupplierBalance": {
      showEndDate: true,
    },
    "PurchaseBySupplier": {
      showDateRange: true,
    },
    "PurchaseByItem": {
      showDateRange: true,
    },
    "PurchaseRegister": {
      showDateRange: true,
    },

    "AvailableSerialNumbers": {

    },
    "AvailableBatches": {

    },
    "AgeingReceipt": {
      showEndDate: true,
    },
    "AgeingPayable": {
      showEndDate: true,
    },
    "ItemTransactionReport": {
      showDateRange: true,
    },
    "JournalEntries": {
      showDateRange: true,
    },
    "BalanceSheet": {
      showEndDate: true,
    },
    "TrialBalance": {
      showEndDate: true,
    },
    "ProfitAndLoss": {
      showEndDate: true,
    },
    "DetailedLedger": {
      showDateRange: true,
    },
    "Ledger": {
      showDateRange: true,
    },
    "DayBook": {
      showEndDate: true,
    },
    "DayBookByLocation": {
      showEndDate: true,
    },
    "DayBookByEmployee": {
      showEndDate: true,
    },
    "PaymentCollectionByEmployee": {
      showEndDate: true,
    },
    "AttendanceByDate": {
      showEndDate: true,
    },
    "AttendanceByEmployee": {
      showDateRange: true,
    }
  }

  const [quickFilterOptions, setQuickFilterOptions] = useState([]);
  const [quickFilterKey, setQuickFilterKey] = useState(queryParams.quickFilterKey || props.quickFilterKey || null);
  const [quickFilterValue, setQuickFilterValue] = useState(queryParams.quickFilterValue || props.quickFilterValue || null);

  const [startDate, setStartDate] = useState(settingsMap[moduleName]?.defaultStartDate ? settingsMap[moduleName]?.defaultStartDate : dayjs().startOf('day').toDate());
  const [endDate, setEndDate] = useState(settingsMap[moduleName]?.defaultEndDate ? settingsMap[moduleName]?.defaultEndDate : dayjs().endOf('day'));

  const [name, setName] = useState(null);

  const { modalStore: { getOpenModals, setOpenModal }, layoutStore: { isSideBarCollapsed, toggleSideBarCollapsed, getSideBarPosition, setSideBarPosition } } = useStores();

  let moduleName = props.moduleName || route.name || props.route?.params?.name;

  if (Platform.OS != 'web') {
    moduleName = props.route?.params?.name || moduleName;
  }

  const [createData, setCreateData] = useState(null);
  const [tabFilter, setTabFilter] = useState({});

  const getModuleData = async () => {
    setLoading(true);

    let payload = {
      reportName: moduleName,
      page: pageIndex,
      limit: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      filters: selectedFilters,
      search: search,
      groupBy: groupBy,
      startDate: startDate,
      endDate: endDate,
      tabFilter: tabFilter,
    };

    console.log("quickFilterKey", quickFilterKey);
    console.log("quickFilterValue", quickFilterValue);

    if (quickFilterKey) {
      payload[quickFilterKey] = quickFilterValue;
    }

    let res = await api.customRoute("getReport", payload);

    let { data, all_columns = [], selected_columns = [], filters, createData = {} } = res;

    setCreateData(createData);

    setRows(data?.data || []);
    setTotal(data?.total || 0);

    selected_columns = selected_columns.filter((column) => {
      if (!column.field) {
        return false;
      }
      if (column.accessor == "actions") {
        return false;
      }
      column.Header = column.label;
      column.accessor = column.field;

      if (column.width) {
        const width = "" + column.width;
        column.width = width.replace('px', '');
      }

      return true;
    });

    if (selected_columns.length === all_columns.length) {
      selected_columns = selected_columns.filter((col) => col.visible);
    }

    selected_columns.push({ Header: (props) => null, accessor: 'actions', width: 75, minWidth: 75 });

    const allColumns = all_columns.map((col, index) => ({
      ...col,
      id: index,
      visible: selected_columns.find((c) => c.field === col.field) ? true : false,
      width: selected_columns.find((c) => c.field === col.field) ? selected_columns.find((c) => c.field === col.field).width : 150,
    }))

    setAllColumns(allColumns || []);
    setSelectedColumns(selected_columns || []);
    setFilters(filters || []);
    setQuickFilterOptions(res.quickFilterOptions || []);

    if (res.quickFilterKey && !quickFilterKey) {
      setQuickFilterKey(res.quickFilterKey || null);
    }

    setLoading(false);
  }

  const download = async (type) => {
    const payload = {
      reportName: moduleName,
      page: pageIndex,
      limit: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      filters: selectedFilters,
      search: search,
      type: type,
      groupBy: groupBy,
      startDate: startDate,
      endDate: endDate,
      tabFilter: tabFilter,
    };

    if (quickFilterKey) {
      payload[quickFilterKey] = quickFilterValue;
    }

    const data = await api.customRoute("getReport", payload);

    api.download(data, type);
  }

  const saveColumns = async (columns, reload = true) => {
    await api.customRoute("saveColumnsReports/" + moduleName, {
      columns: columns,
    });

    if (reload) {
      setTimeout(() => {
        getModuleData();
      }, 0);
    }
  }

  const goBack = () => {
    if (Platform.OS === 'web') {
      window.history.back();
    } else {
      navigation.goBack();
    }
  }

  useEffect(() => {
    if (Platform.OS === 'web') {
      let path = window?.location?.pathname;
      route = { name: path.split("/")[2] || 'Items' };
      getModuleData();
    } else {
      getModuleData();
    }
  }, [window?.location?.pathname, search, groupBy, selectedFilters, sortColumn, sortDirection, pageIndex, pageSize, startDate, endDate, quickFilterValue, tabFilter]);

  useEffect(() => {
    if (queryParams.quickFilterKey && queryParams.quickFilterValue) {
      setQuickFilterKey(queryParams.quickFilterKey);
      setQuickFilterValue(queryParams.quickFilterValue);
    }

    if (queryParams.startDate) {
      setStartDate(moment(queryParams.startDate).toDate());
    }

    if (queryParams.endDate) {
      setEndDate(moment(queryParams.endDate).toDate());
    }
  }, [queryParams.quickFilterKey, queryParams.quickFilterValue, props.quickFilterKey, props.quickFilterValue, queryParams.startDate, queryParams.endDate]);

  useEffect(() => {
    DeviceEventEmitter.addListener("reloadListing", (event) => {
      getModuleData();
    })

    return () => {
      DeviceEventEmitter.removeAllListeners("reloadListing");
    }
  }, []);

  const globalData = GlobalMasterStore((state) => state.globalData);

  useEffect(() => {
    const organization_id = globalData?.organization_id;
    const organizations = globalData?.organizations;
    const organization = organizations?.find((o) => o.id == organization_id);
    setName(organization?.name);
  }, [globalData]);


  const Table = <DynamicTable
    data={rows}
    updateData={(newData) => {
      setRows(newData)
    }}
    columns={selectedColumns}
    allColumns={allColumns}
    hideLabelOnMobile={true}
    cfAdd={true}
    saveColumns={saveColumns}
    isGrouped={groupBy ? true : false}
    mono={props.noMono ? false : true}
    // total={total}
    // pageSize={pageSize}
    // pageIndex={pageIndex}
    // onQueryParams={onQueryParams}
    // showCheckbox={true}
    resizable={true}

    startDate={moment(startDate).format('YYYY-MM-DD')}
    endDate={moment(endDate).format('YYYY-MM-DD')}
    selectedFilters={selectedFilters}
    groupBy={groupBy}
  />

  const newModule = () => {
    if (Platform.OS === 'web') {
      const query = {}
      const params = window.location.search.substring(1).split('&')
      params.map((param) => {
        const [key, value] = param.split('=')
        if (key) {
          query[key] = value;
        }
      })
      navigationFn('New/' + moduleName, {
        moduleName: moduleName,
        ...query,
        goBackAfterSave: true
      })

    } else {
      navigationFn('New', {
        moduleName: moduleName,
        goBackAfterSave: true
      })
    }
  }

  const readableModuleName = moduleName?.replace(/([A-Z])/g, ' $1').trim();



  const MainWrapper = useCallback(({ children }) => {
    return !props.hideWrapper ? <>
      <LayoutScreen>
        {Platform.OS == 'web' && <View marginT-2 style={{
          flex: 1,
        }} padding-20>
          <Card padding-10 style={{
            height: Dimensions.get('window').height - 100,
          }}>
            {children}
          </Card>
        </View>}

        {Platform.OS != 'web' && <View marginT-2 style={{
          flex: 1,
        }} padding-10>
          {children}
        </View>}

      </LayoutScreen>
    </> : <>
      {children}
    </>
  }, [props.hideWrapper])

  const CustomFilter = settingsMap[moduleName].customFilter;

  return (
    <MainWrapper>
      {/* <Card padding-10> */}

      <View spread centerV row paddingB-10 marginT-5 marginB-10 style={{
        borderBottomColor: '#0000000d',
        borderBottomWidth: 1,
        width: '100%'
      }}>
        <View row centerV>
          {settingsMap[moduleName] && settingsMap[moduleName].showDateRange && <View row centerV>
            <View marginR-10>
              <CustomDatePicker dateTime={true} allowClear={false} placeholder="Start Date" value={startDate} onChange={(e) => {
                setStartDate(e);
              }} />
            </View>
            <View>
              <Icon name='arrow-forward-outline' width={16} height={16} fill='#53535f' />
            </View>
            <View marginL-10>
              <CustomDatePicker dateTime={true} allowClear={false} placeholder="End Date" value={endDate} onChange={(e) => {
                setEndDate(e);
              }} />
            </View>
          </View>}

          {settingsMap[moduleName] && settingsMap[moduleName].showEndDate && <View row centerV>
            <View marginL-10>
              <CustomDatePicker dateTime={true} placeholder="End Date" value={endDate} onChange={(e) => {
                setEndDate(e);
              }} />
            </View>
          </View>}
        </View>

        <View row centerV>
          {Platform.OS == 'web' ? (queryParams.hideQuickFilter) ? null : <View style={{
            minWidth: 150,
          }}>
            {quickFilterOptions && quickFilterOptions.length > 0 && <CustomSelect
              label="Quick Filter"
              width={150}
              options={quickFilterOptions}
              value={quickFilterValue}
              onChange={(value) => {
                setQuickFilterValue(value);
              }}
            />}
          </View> : null}

          {/* {filters.length > 0 && <SecondaryButton onPress={() => {
            setShowFilter(true);
          }} style={{ marginLeft: 10 }}>
            <View row centerV>
              <Icon name='options-2-outline' width={16} height={16} fill='#53535f' />
              <View marginL-5>
                <Text>Filter</Text>
              </View>
            </View>
          </SecondaryButton>} */}

          {/* <SecondaryButton onPress={() => {
            setGroupByModal(true);
          }} style={{ marginLeft: 10 }}>
            <View row centerV>
              <Icon name='folder-outline' width={16} height={16} fill='#53535f' />
              <View marginL-5>
                <Text>Group By</Text>
              </View>
            </View>
          </SecondaryButton> */}

          {Platform.OS == 'web' ? <Dropdown
            menu={{
              items: [{
                label: 'Excel',
                onClick: () => {
                  download('excel');
                }
              }, {
                label: 'PDF',
                onClick: () => {
                  download('pdf');
                }
              }]
            }}

          >
            <View>
              <SecondaryButton onPress={(e) => {
                e?.preventDefault();
              }} style={{ marginLeft: 10 }}>
                <View row centerV>
                  <Icon name='cloud-download-outline' width={16} height={16} fill='#53535f' />
                  <View marginL-5>
                    <Text>Export</Text>
                  </View>
                </View>
              </SecondaryButton>
            </View>

          </Dropdown> :
            <Button label="Export" onPress={() => setShowExport(true)} style={{ marginLeft: 10 }} />}

          {!props.hideHeader && Platform.OS == 'web' && <SecondaryButton onPress={() => {
            goBack()
          }} style={{ marginLeft: 10 }} >
            <Icon name='close-outline' width={16} height={16} fill='#53535f' />
          </SecondaryButton>}
        </View>
      </View>


      {settingsMap[moduleName] && settingsMap[moduleName].customFilter && <View>
        {CustomFilter && <CustomFilter tabFilter={tabFilter} setTabFilter={setTabFilter} createData={createData} />}
      </View>}

      <View>
        {Platform.OS != 'web' ? queryParams.hideQuickFilter ? null : <View style={{
          minWidth: 150
        }}>
          {quickFilterOptions && quickFilterOptions.length > 0 && <CustomSelect
            label="Quick Filter"
            width={150}
            options={quickFilterOptions}
            value={quickFilterValue}
            onChange={(value) => {
              setQuickFilterValue(value);
            }}
          />}
        </View> : null}
      </View>

      {!props.hideHeader && <View row center marginB-20>
        <View center>
          <Text formlabel monoBold> {name} </Text>
          <Text formlabel monoRegular> {readableModuleName} </Text>
          {settingsMap[moduleName] && settingsMap[moduleName].showDateRange && <Text formlabel monoRegular> FROM {dayjs(startDate).format('DD MMM YYYY')} TO {dayjs(endDate).format('DD MMM YYYY')} </Text>}

          {settingsMap[moduleName] && settingsMap[moduleName].showEndDate && <Text formlabel monoRegular> AS ON {dayjs(endDate).format('DD MMM YYYY')} </Text>}

          {!(settingsMap[moduleName] && settingsMap[moduleName].showDateRange) && !(settingsMap[moduleName] && settingsMap[moduleName].showEndDate) && <Text formlabel monoRegular> AS ON {dayjs().format('DD MMM YYYY')} </Text>}
        </View>
      </View>}

      <View left flex-5 flexG>
        <View flex style={{ width: '100%' }}>
          {!loading ? Table : <Text>Loading...</Text>}
        </View>
      </View>

      <CustomModal
        title="Apply FIlters"
        visible={showFilter}
        onClose={() => setShowFilter(false)}
      >
        {selectedFilters.length > 0 && <View left marginT-20>
          {selectedFilters.map((filter, index) => (
            <Chip key={index} label={`${filter.label} ${filter.operator_label} ${filter.value}`} onPress={() => {
              let selectedFiltersNew = [...selectedFilters];
              selectedFiltersNew.splice(index, 1);
              setSelectedFilters(selectedFiltersNew);
            }} />
          ))}
        </View>}

        {/* <View row>
                <View marginR-10>
                  <Icon name='search-outline' width={16} height={16} fill='#53535f' />
                </View>

                <TextField placeholder="Search" value={search} onChange={(e) => {
                  setSearch(e.nativeEvent.text);
                }} />

                <View marginR-10>
                  <View style={{ width: 1, height: 16, backgroundColor: '#e0e0e0', marginHorizontal: 10 }} />
                </View>
              </View> */}

        <View row marginT-20>
          <View marginR-10 flex>
            <CustomSelect
              label="Field"
              options={filters.map(filter => ({ label: filter.label, value: filter.field }))}
              value={filter.field}
              onChange={(value) => {
                const selectedFilter = filters.find(filter => filter.field === value);
                const filterNew = { ...filter };
                filterNew.field = selectedFilter?.field;
                filterNew.operators = selectedFilter?.operators;
                filterNew.type = selectedFilter?.type;
                filterNew.operator = selectedFilter?.operators[0].value;
                filterNew.route = selectedFilter?.route;
                filterNew.routeParams = selectedFilter?.routeParams;
                setFilter(filterNew);
              }}
            />
          </View>
          <View marginR-10 flex>
            <CustomSelect
              label="Operator"
              options={filter.operators || []}
              value={filter.operator}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.operator = value;
                setFilter(filterNew);
              }}
            />
          </View>
          <View flex>
            {filter.type == 'select' && <CustomSelect
              multiple
              label="Value"
              options={filter.options || []}
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
              searchRoute={filter.route}
              searchRouteParams={filter.routeParams}
            />}

            {filter.type == 'text' && <CustomTextField
              label="Value"
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

            {filter.type == 'number' && <CustomNumberInput
              label="Value"
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

            {filter.type == 'date' && <CustomDatePicker
              label="Value"
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

            {filter.type == 'datetime' && <CustomDateTimePicker
              label="Value"
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

            {filter.type == 'time' && <CustomTimePicker
              label="Value"
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

            {filter.type == 'boolean' && <CustomSelect
              label="Value"
              options={[{ label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }]}
              value={filter.value}
              onChange={(value) => {
                const filterNew = { ...filter };
                filterNew.value = value;
                setFilter(filterNew);
              }}
            />}

          </View>
        </View>

        <View marginT-15 row>
          <Button
            marginR-10
            label="Add"
            onPress={() => {
              let selectedFiltersNew = [...selectedFilters];

              const label = filters.find(fil => fil.field === filter.field)?.label;
              const operator_label = filter.operators.find(operator => operator.value === filter.operator)?.label;

              selectedFiltersNew.push({
                field: filter.field,
                label: label,
                operator: filter.operator,
                operator_label: operator_label,
                value: filter.value
              });

              setSelectedFilters(selectedFiltersNew);

              setFilter({
                field: null,
                label: null,
                operator: null,
                operator_label: null,
                operators: [],
                type: "text",
                value: null
              });
            }}
          />
          <Button
            outline
            label="Clear All"
            onPress={() => {
              setSelectedFilters([]);
            }}
          />
        </View>

      </CustomModal>

      <CustomModal
        drawer
        title="Group By"
        visible={groupByModal}
        onClose={() => {
          setGroupByModal(false);
        }}
      >
        <View flex useSafeArea>

          <TouchableOpacity
            onPress={() => {
              setGroupByModal(false);
              setGroupBy(null);
            }}
          >
            <View row style={{ cursor: 'grab' }}>
              <Image assetName="drag" style={{ width: 20, height: 20, opacity: 0.2 }} />
              <Text text-90N grey10>
                None
              </Text>
            </View>
          </TouchableOpacity>

          {allColumns.map((item, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => {
                setGroupByModal(false);
                setGroupBy(item.field);
              }}
            >
              <View row style={{ cursor: 'grab' }}>
                <Image assetName="drag" style={{ width: 20, height: 20, opacity: 0.2 }} />
                <Text text-90N grey10 key={item.field}>
                  {item.label}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </CustomModal>

      <ActionSheet
        useNativeIOS
        visible={showExport}
        title={'Title'}
        message={'Message goes here'}
        cancelButtonIndex={2}
        onDismiss={() => setShowExport(false)}
        options={[
          { label: 'Excel', onPress: () => download('excel') },
          { label: 'PDF', onPress: () => download('pdf') },
          { label: 'Cancel', onPress: () => setShowExport(false) }
        ]}
      />
    </MainWrapper>
  )
}

export default ReportScreenSingle

const $container = {
  flex: 1,
}